import { render, staticRenderFns } from "./listRole.vue?vue&type=template&id=aa2f1638&"
import script from "./listRole.vue?vue&type=script&lang=js&"
export * from "./listRole.vue?vue&type=script&lang=js&"
import style0 from "./listRole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports